<div #containerEl [ngClass]="panelMode" class="p-grid container" style="padding: 0">
    <ng-container [ngSwitch]="panelMode">

        <div class="p-col-12" *ngSwitchCase="'single'">
            <ng-container *ngTemplateOutlet="selected ? contentSetupTemplate : selectorSetupTemplate"></ng-container>
        </div>

        <ng-container *ngSwitchCase="'dual'">
            <div class="p-col-5">
                <ng-container *ngTemplateOutlet="selectorSetupTemplate"></ng-container>
            </div>
            <div class="p-col-7">
                <ng-container *ngTemplateOutlet="contentSetupTemplate"></ng-container>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #selectorSetupTemplate>
    <div>
        <div *ngIf="headerTemplate" class="header p-my-3">
            <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="selectorTemplate || defaultListTemplate"></ng-container>
    </div>
</ng-template>

<ng-template #contentSetupTemplate>
    <div>
        <div *ngIf="panelMode === 'single'" class="p-mb-2">
            <button pButton label="Back" icon="pi pi-chevron-left" (click)="clearSelected()"></button>
        </div>
        <div class="content-display">
            <ng-container *ngTemplateOutlet="selected ? contentTemplate : emptyTemplate; context: {$implicit: selected}"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #defaultListTemplate>
    <div style="overflow: auto">
        <p-table #defaultListTable [value]="items" [loading]="loading">
            <ng-template pTemplate="body" let-item>
                <tr [ngClass]="{'p-highlight': item.value === selected}" class="clickable" (click)="selected = item.value">
                    <td>
                        {{item.display}}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</ng-template>